<template>
  <div class="core-wrapper">
    <h1 class="core-page-title">{{ $t(messageKey + '.title') }}</h1>
    <div class="core-container bg-error-light text-error-dark">
      <div class="flex justify-between items-center">
        <p>{{ $t(messageKey + '.message') }}</p>
        <button
          @click="reload"
          type="button"
          v-tooltip="$t('general.button.reload')"
          class="reload-button data-v-tooltip">
          <IconRefresh class="h-5 w-5" stroke="1.8" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { IconRefresh } from '@tabler/icons-vue'
import { useClientStore } from '@/stores/client'

const route = useRoute()
const router = useRouter()
const clientStore = useClientStore()
const messageKey = route.params?.key

function reload() {
  router.push({ name: 'reload', params: { path: clientStore.clientFullPath } })
}
</script>

<style lang="postcss" scoped>
.reload-button {
  @apply border-2 rounded-sm border-error-dark bg-white;
  @apply hover:border-error-default hover:text-error-default;
  @apply flex justify-center items-center;
  @apply h-10 w-10;
}
</style>
